(ns frontend.ux-overhaul.listing.sample-entities.view
  (:require
   [common.localization :as loc]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.routing :as routing]
   [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
   [frontend.ux-overhaul.listing.generic.event :as generic-event]
   [frontend.ux-overhaul.listing.generic.view :as listing]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def listing-id "sample-entities-listing")

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id             listing-id
         :initial-view-mode      :grid
         :entity-type            :entity.type/sample-entity
         :pipeline-id            nil
         :filters                {:enabled? true
                                  :view-id :sample-entities
                                  :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes   #{:kanban :grid :gallery :list}
         :toolbar-actions        []}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [listing/view
       {:listing-id               listing-id
        :show-view-mode-selector? true
        :query-placeholder        (loc/tr :listing.sample-entity/search-placeholder)}])}))

(defmethod routing/render-view :sample-entities
  [_]
  [default-page-layout/view
   [page-content]])
